<template>
  <div class="index-box">
    <div class="index-item-box" style="padding: 0.25rem 0.05rem 0;">
      <div class="index-item-title-box" style="margin-left: 0.15rem;">
        <div class="index-item-title-line"></div>
        <div class="index-item-title">特色功能</div>
      </div>
      <div class="index-top-box">
        <div class="index-top-item-box" @click="goNext(0)">
          <img src="@/assets/image/1.png">
        </div>
        <div class="index-top-item-box" @click="goNext(1)">
          <img src="@/assets/image/2.png">
        </div>
        <div class="index-top-item-box" @click="goNext(2)">
          <img src="@/assets/image/3.png">
        </div>
      </div>
    </div>
    <div class="index-item-box">
      <div class="index-item-title-box">
        <div class="index-item-title-line"></div>
        <div class="index-item-title">常用功能</div>
      </div>
      <div class="index-bottom-box">
        <div class="index-bottom-item-box" @click="goNext(3)">
          <img src="@/assets/image/不动产税费计算器.png">
        </div>
        <div class="index-bottom-item-box" @click="goNext(4)">
          <img src="@/assets/image/个人所得税申报记录查询-自然人电子税务局.png">
        </div>
        <div class="index-bottom-item-box" @click="goNext(5)">
          <img src="@/assets/image/发票查询.png">
        </div>
        <div class="index-bottom-item-box" @click="goNext(6)">
          <img src="@/assets/image/电子税务局业务办理.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods: {
    goNext(e) {
      if(e == 0) {
        window.location.href = 'https://etax.heilongjiang.chinatax.gov.cn/'
      } else if(e == 1) {
        window.location.href = 'http://heilongjiang.chinatax.gov.cn/art/2020/3/31/art_16296_295233.html'
      } else if(e == 2) {
        this.$router.push('/list')
      } else if(e == 3) {
        this.$router.push('/bdcmmjsq')
      } else if(e == 4) {
        window.location.href = 'https://etax.chinatax.gov.cn/'
      } else if(e == 5) {
        window.location.href = 'https://etax.heilongjiang.chinatax.gov.cn/nologin/xxcx/ptfplxcx.jsp'
      } else if(e == 6) {
        window.location.href = 'https://etax.heilongjiang.chinatax.gov.cn/'
      }
    },
  },
}
</script>

<style scoped>
  .index-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #f2f3f8;
    overflow: auto;
  }
</style>

<style src="@/assets/css/css.css" scoped></style>